import { defineComponent, useListeners, computed, inject, watch } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useItemClickHandler } from '../../composables/item-click-handler/index.js';
import { useCursorPagination } from '../../composables/cursor-pagination/index.js';
import { useImageLoading } from '../../composables/image-loading/index.js';
import UiCursorPagination from '../ui-cursor-pagination/UiCursorPagination.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';
import { isToday } from 'date-fns';
import { showResults, showNoResults } from '../../helpers/data.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NewsList",
  props: {
    criteria: { type: null, required: false },
    showSummary: { type: [Boolean, Number], required: false, default: false },
    locale: { type: null, required: true },
    itemsPerPage: { type: Number, required: false, default: 10 }
  },
  emits: ["store-error", "data-load", "item-key-click", "item-click", "read-more-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const previousPageCursor = computed(() => {
      var _a, _b;
      return (_b = (_a = storeMeta.value) == null ? void 0 : _a.pagination.previous) != null ? _b : void 0;
    });
    const nextPageCursor = computed(() => {
      var _a, _b;
      return (_b = (_a = storeMeta.value) == null ? void 0 : _a.pagination.next) != null ? _b : void 0;
    });
    const cursorPagination = useCursorPagination(props);
    const { activePageCursor, itemsPerPage, onClickPagination } = cursorPagination;
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, textFormat, numberFormat, dateFormat, relativeTimeFormat } = localizationSupport;
    const itemClickHandler = useItemClickHandler(listeners, emits);
    const { hasItemKeyClickListener, hasItemClickListener, itemClickHandlerAttributes, itemClickHandlerEvents, itemClickHandlerKeyEvents } = itemClickHandler;
    const componentInputs = computed(() => ({
      criteria: props.criteria,
      language: props.locale,
      showSummary: props.showSummary,
      itemsPerPage: itemsPerPage.value,
      activePageCursor: activePageCursor.value
    }));
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, storeMeta, storeCleanUp, storeRequestData, isLoadingStoreData } = storeModule;
    const { imageLoading, watchImage } = useImageLoading();
    const hasSummary = (index) => {
      if (typeof props.showSummary === "boolean") {
        return props.showSummary;
      }
      return index < props.showSummary;
    };
    const isCurrentDay = (time) => {
      return time !== null && isToday(time);
    };
    const onReadMoreClick = (item) => {
      emits("read-more-click", item);
    };
    watch([() => [props.criteria, props.itemsPerPage, props.locale]], () => {
      cursorPagination.activePageCursor.value = null;
    });
    return { __sfc: true, props, emits, listeners, previousPageCursor, nextPageCursor, cursorPagination, activePageCursor, itemsPerPage, onClickPagination, localizationSupport, translate, textFormat, numberFormat, dateFormat, relativeTimeFormat, itemClickHandler, hasItemKeyClickListener, hasItemClickListener, itemClickHandlerAttributes, itemClickHandlerEvents, itemClickHandlerKeyEvents, componentInputs, storeModule, storeData, storeMeta, storeCleanUp, storeRequestData, isLoadingStoreData, imageLoading, watchImage, hasSummary, isCurrentDay, onReadMoreClick, UiCursorPagination, HoistComponent, showResults, showNoResults };
  }
});

export { _sfc_main as default };
